<!--Header section starts-->
<header class="navbar-fixed-top acmt-header position-relative">
  <div class="container-fluid" ng-controller="header">
    <div class="acmt-logo col-md-1 col-sm-1"><a href="#/project/list"><span> Frost align</span></a></div>
    <nav class="col-md-9 col-sm-9 nav_links">
      <a [routerLink]="['project/list']" class="active_nav">Projects</a>
      <a [routerLink]="['taxonomy']">Taxonomies</a>
      <a class="disabled">Metadata</a>
      <a class="disabled">Workflows</a>
      <a>Admin</a>
    </nav>
    <div class="col-md-2 col-sm-2 header_right_section">
      <div class="col-md-5 col-sm-5 notifications">
        <em class="material-icons-outlined font-4x" aria-hidden="true">
          notifications
        </em>
      </div>
      <div class="col-md-6 col-sm-7 username">
        <div class="dropdown-toggle" data-toggle="dropdown">
          <span>Hi {{user_name}}</span><span>
            <em class="material-icons-outlined font-4x" aria-hidden="true">
              arrow_drop_down
            </em>
          </span>
        </div>
        <ul class="dropdown-menu" role="menu">
          <li><a href="#/profile">My Profile</a></li>
          <li><a href="#/logout">Log Out</a></li>
        </ul>
      </div>
    </div>
  </div>
</header>
<!--Header section ends-->
